export const DISPATCH_METHODS = {
  DELIVERY: 'store_delivery',
  PICKUP: 'in_store'
};

export const ENTER_ADDRESS = {
  ENTER_ADDRESS: 'enter_address'
};
